import { render, staticRenderFns } from "./VirtualOrgField.vue?vue&type=template&id=0facf42f"
import script from "./VirtualOrgField.vue?vue&type=script&lang=js"
export * from "./VirtualOrgField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports